import { userPool } from 'store/userPool';

function getTimeMode(localStorageItem) {
  if( localStorageItem && localStorageItem!== 'undefined' ) {
    return localStorageItem;
  }
  return 'UTC';
}

const initState = {
  cognitoUser: userPool.getCurrentUser(),
  awsCredentials: {},
  awsRegion: null,
  user: {
    group: '',
    username: '',
    email: '',
    hasSuperPermission: false,
  },
  userLoaded: false,
  loginError: '',
  timeMode: getTimeMode(localStorage.getItem('EMS_active_timeMode')),
  preferredTzMode: 'UTC',
  client: null,
  mfaConfigured: null,
  showMap: true,
  unitFaultAudioAlarmEnabled: false,
  unitFaultBannerAlarmEnabled: false,
};

export default (state = initState, action) => {
  const handlers = {
    'LOGIN_SUCCESS': () => {
      const newState = {...state};
      const groups = action.userdata.getIdToken().payload['cognito:groups'];
      if (groups && groups[0]) {
        newState.user.group = groups[0];
      }else{
        newState.user.group = false;
      }
      newState.userLoaded = true;
      newState.user.username = action.userdata.getIdToken().payload['cognito:username'];
      newState.user.email = action.userdata.getIdToken().payload['email'];
      const tz = action.userdata.getIdToken().payload['custom:preferred_timezone'];
      const showMap = action.userdata.getIdToken().payload['custom:show_map'];
      const unitFaultAudioAlarmEnabled = action.userdata.getIdToken().payload['custom:fault_audio_alarm'];
      const unitFaultBannerAlarmEnabled = action.userdata.getIdToken().payload['custom:fault_banner_alarm'];
      const hasSuperPermission = action.userdata.getIdToken().payload['custom:has_super_permission'] === 'true';
      if (tz) {
        newState.preferredTzMode = tz;
      }
      if (action.fromLogin) {
        newState.timeMode = tz || 'UTC';
        localStorage.setItem('EMS_active_timeMode', tz);
      }
      if (showMap) {
        newState.showMap = showMap === 'true';
      }
      if (unitFaultAudioAlarmEnabled) {
        newState.unitFaultAudioAlarmEnabled = unitFaultAudioAlarmEnabled === 'true';
      }
      if (unitFaultBannerAlarmEnabled) {
        newState.unitFaultBannerAlarmEnabled = unitFaultBannerAlarmEnabled === 'true';
      }
      if (hasSuperPermission) {
        newState.user.hasSuperPermission = hasSuperPermission;
      }

      return newState;
    },
    'LOGIN_ERROR': () => {
      return {...state, loginError: action.err};
    },
    'USER_LOADED': () => {
      return {...state, userLoaded: true};
    },
    'LOGOUT': () => {
      return {...state, user: { username: '' }, mfaConfigured: null, userLoaded: false};
    },
    'UPDATE_USER_MODULE': () => {
      delete action.type;
      return {...state, ...action};
    },
  };
  if (!handlers[action.type])
    return state;
  return handlers[action.type]();
};